module.exports = __webpack_public_path__ + "fonts/IstokWeb-Bold.71ebc6fb.ttf";